"use client";

import AlertFooter from "./AlertFooter";
import FeedbackNudge from "./FeedbackNudge";

/**
 * Renders a single footer slot at the bottom of the chat UI.
 * AlertFooter takes priority when an alert is configured and enabled.
 * Otherwise, FeedbackNudge may appear based on random probability.
 */
export default function FooterSlot() {
  const alertEnabled =
    process.env.NEXT_PUBLIC_ALERT_ENABLED === "true" &&
    !!process.env.NEXT_PUBLIC_ALERT_MESSAGE;

  if (alertEnabled) {
    return <AlertFooter />;
  }

  return <FeedbackNudge />;
}
